import WithdrawalReceiptHistory from "./WithdrawalReceiptHistory";

export default WithdrawalReceiptHistory;
